/**
 * Failed-job placeholder art: 6 bundled cartoon "THIS JOB HAS FAILED" variants
 * (generated with the shared platform image engine). Stable per job — the same
 * failed song always shows the same unlucky character.
 */
export function failArtFor(jobId: string): string {
  let h = 0;
  for (let i = 0; i < jobId.length; i++) h = (h * 31 + jobId.charCodeAt(i)) >>> 0;
  return `/failed/fail-${(h % 6) + 1}.webp`;
}
